var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "date-inputs" }, [
    _c("div", [
      _c(
        "div",
        { staticClass: "date-inputs--day" },
        [
          _c("b-input", {
            attrs: { type: "text", placeholder: "TT" },
            on: { input: _vm.dayChanged },
            model: {
              value: _vm.day,
              callback: function($$v) {
                _vm.day = $$v
              },
              expression: "day"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "date-inputs--point" }, [_vm._v(".")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "date-inputs--month" },
        [
          _c("b-input", {
            ref: "month",
            attrs: { type: "text", placeholder: "MM" },
            on: { input: _vm.monthChanged },
            model: {
              value: _vm.month,
              callback: function($$v) {
                _vm.month = $$v
              },
              expression: "month"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "date-inputs--point" }, [_vm._v(".")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "date-inputs--year" },
        [
          _c("b-input", {
            ref: "year",
            attrs: { type: "text", placeholder: "JJJJ" },
            on: { input: _vm.yearChanged },
            model: {
              value: _vm.year,
              callback: function($$v) {
                _vm.year = $$v
              },
              expression: "year"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.showError
      ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }